<template>
  <div>
    <h6 class="text-center">
      {{
        {
          REAJUSTE_MANUAL: "VALORES E DATAS DAS ÚLTIMAS 5 COMPRAS",
          REAJUSTE_VALOR_MEDIO: "VALORES E DATAS DAS ÚLTIMAS 3 COMPRAS",
          REAJUSTE_MAIOR_VALOR: "VALOR E DATA DA MAIOR COMPRA",
        }[readjustment] || "VALORES E DATAS DAS ÚLTIMAS 5 COMPRAS"
      }}
    </h6>
    <b-overlay :show="loading" opacity="0.99">
      <div class="v-clean p-2 text-center" v-show="data.length == 0">
        <h6 class="text-center upper-text worksansr m-0">SEM RESULTADOS!</h6>
      </div>
      <v-data-table
        v-show="data.length > 0"
        dense
        :headers="headers"
        :items="data"
        :search="search"
        item-key="id"
        :footer-props="{
          'items-per-page-options': [5],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
        hide-default-footer
      >
        <template v-slot:[`item.value`]="{ item }">
          {{ formatReal(item.value) }}
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ moment(item.created_at).format("DD/MM/YYYY") }}
        </template>
      </v-data-table>
      <errors-messages :errors="errors" />
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import api from "../../../services/api";

import moment from "moment";

import { formatReal } from "../../../lib/format";

export default {
  name: "LatestReleasesPriceList",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      search: "",

      total: 0,
      options: {},

      headers: [
        { text: "VALOR", value: "value", sortable: false },
        { text: "DATA", value: "created_at", sortable: false },
      ],

      data: [],

      errors: [],

      loading: false,
    };
  },

  props: {
    type: String,
    readjustment: String,
    id: [String, Number],
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },

    readjustment() {
      this.handleReadjustment();
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    formatReal,

    retrieve() {
      this.handleReadjustment();
    },

    handleReadjustment() {
      this.options.page = 1;
      this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let { id, readjustment } = this;

        const { page, itemsPerPage } = this.options;

        const params = { id, page, itemsPerPage, readjustment };

        const response = await api.get(
          "/rest-home/stock/item/latest-releases-price-list",
          {
            params,
          }
        );

        const { error, errors, data, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
          this.$emit("paginate", data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
